<template>
  <div class="footer-container">
    <div class="content">

      <img src="../../assets/img/wx-code.png" style="height: 100px;margin: 0 20px;" target="_blank"/>

      <div class="col">
        <img src="../../assets/img/logo-big.png"/>

        <div style="padding-top: 5px;">
          武汉市东湖新技术开发区纺织路10号 service@set2025.com
        </div>

        <div style="padding-top: 5px;">
          版权所有：湖北弘和世纪信息技术有限公司
          <a href="https://beian.miit.gov.cn" class="link-text"
             target="_blank">Copyright © 2025 ICP备案号：鄂ICP备2024084960号</a>
        </div>

      </div>



<!--      <div class="links">-->
<!--        <div>-->
<!--          <span style="font-weight: bold">友情链接：</span>-->
<!--        </div>-->
<!--        <div style="padding-top: 4px;">-->
<!--          <a href="https://www.gbtool.cn/" target="_blank">-->
<!--          国标兔文档助手-->
<!--        </a>-->
<!--        </div>-->


<!--      </div>-->

    </div>

  </div>

</template>

<script>


export default {
  name: 'Footer',

  data() {
    return {}
  },

  mounted() {

  },

  watch: {
    $route: {
      handler(to) {


      },
      immediate: true
    },
  },

  methods: {}

}
</script>
<style lang="scss" scoped>
.footer-container {
  .content {
    width: 1000px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  border-top: 1px solid #EEEEEE;
  margin-top: 4px;
  padding: 10px 0 20px 0;
  background: #FFF;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: start;
  align-items: center;
  font-size: 15px;
  color: rgba(57, 60, 68, 0.9);

  .col {
    display: flex;
    flex-direction: column;
    align-items: start;

    img {
      height: 50px;
      object-fit: contain;
    }
  }
}

.a-view {
  width: 240px;
  margin: 4px;
}

.link-text {


  border-bottom: 1px solid transparent;

}

.link-text:hover {
  border-bottom: 1px solid rgba(57, 60, 68, 0.9);
}

.links {
  margin-left: 100px;
  border-left: 1px solid #BBBBBB;
  height: 100px;
  padding-left:20px;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}
</style>
